import type { ErrorType } from '../itineraries';

export const ErrorValues: {
  UNAVAILABLE: ErrorType;
  NONE: ErrorType;
  TIMEOUT: ErrorType;
  GENERAL: ErrorType;
} = {
  UNAVAILABLE: 'UNAVAILABLE',
  NONE: 'NONE',
  TIMEOUT: 'TIMEOUT',
  GENERAL: 'GENERAL',
};
